import { useCallback, useState, useEffect } from "react";
import EventCard from "../component/EventCard";
import InputCard from "../component/InputCard";
import { useDecodedParams } from "../misc/utils";
import { useForm, Controller } from "react-hook-form";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import ExampleComp from "../component/ExampleComp";
import InputDonationCard from "../component/InputDonationCard";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAws } from "../aws";
import { set } from "lodash";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Banner from "../assets/banner.jpeg";

const DonationPage = () => {
  const { x_api_key, x_api_key_cms, apiStage } = useAws();
  const { t, i18n } = useTranslation();
  const { id } = useDecodedParams();
  const [userInfo, setUserInfo] = useState({});
  const [paymentMethod, setPaymentMethod] = useState("FPS");
  const hookForm = useForm({ mode: "all" });
  const { handleSubmit, clearErrors, setValue, getValues, trigger, reset } =
    hookForm || {};
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };

  const fetchEventDetailData = useCallback(() => {
    return {
      title: "「自在生活禪」網上課堂",
      img: "https://static.wixstatic.com/media/fddb94_3aa1b5dfa36b4e4c9da47be686821f59~mv2.jpg/v1/crop/x_0,y_0,w_1536,h_1536/fill/w_452,h_452,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/285122639_1127586707788470_7200350188490217031_n.jpg",
      optionsGroups: [
        {
          label: "2022.3.5",
          options: [
            { label: "10:00 AM", price: "50" },
            { label: "11:00 AM", price: "50" },
          ],
        },
        {
          label: "2022.3.12",
          options: [{ label: "10:00 AM" }, { label: "11:00 AM" }],
        },
      ],
    };
  }, []);

  const inputCardProps = {
    hookForm,
    paymentItmeProps: {
      paymentMethod,
      setPaymentMethod,
    },
  };

  const onSubmit = (data) => {
    data = { ...data, paymentMethod: paymentMethod };
    // console.log(data);
    if (paymentMethod == "Card") {
      var isLoading = true;
      const name = {
        prefix: data.prefix,
        en_first_name: data.englishFirstame,
        en_last_name: data.englishLastname,
        zh_first_name: data.chineseFirstname,
        zh_last_name: data.chineseLastname,
      };
      const details = {
        birth_month: data.birthMonth,
        contact_email: data.email,
        contact_phone: data.phoneNumber,
        gender: data.gender,
        name: name,
      };
      axios
        .post(
          apiStage + "/user/donate",
          {
            detail: details,
            amount: data.donationAmount,
            payment_method: paymentMethod,
            promo_terms: data["pi-1"] ? "yes" : "no",
          },
          {
            headers: {
              "x-api-key": x_api_key,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          // console.log(res.data.body);
          data = { ...data, payment_id: res.data.body.id };
          // console.log(data);
          isLoading = false;
          handleStorageDonation(data);
        });
    } else {
      handleStorageDonation(data);
    }
  };

  const handleStorageDonation = (data) => {
    // console.log(data);
    window.sessionStorage.setItem("donation", JSON.stringify(data));
    navigate("/confirmation/donation");
  };

  const printFormData = (event) => {
    if (event.ctrlKey && event.altKey && event.key === "l") {
      // console.log(getValues());
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", printFormData);
  }, []);

  return (
    <div className="page-view event-detail">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <img
        className="logo donation mt-2 mb-6"
        src={Banner}
        alt="pause-and-breathe-logo"
      />
      <form
        key="userInfoForm"
        id="userInfoForm"
        onSubmit={handleSubmit(onSubmit)}
        onKeyPress={(e) => {
          e.key === "Enter" && e.preventDefault();
        }}
      >
        <div
          className={`card-view donation-card`}
          style={{ marginBottom: "40px" }}
        >
          <h1 className="mb-1">{t("Donation")}</h1>
          <p>您願意支持推動全城「停一停 卓嶺有限公司」嗎？</p>
          <p>
            「停一停
            卓嶺有限公司」為本港非牟利慈善團體（慈善團體號碼：91/17061)。團隊深信，在日常生活中，每當生起負面情緒，若能立刻停一停，然後用心感受當下呼吸，負面情緒便
            不會蔓延，冷靜下來後，對解決問題定有幫助。
          </p>
          <p>
            這是一個長遠及需要持續努力的項目，一直以來，我們全賴各界慷慨解囊，讓我們的活動持續、訊息得以廣傳。你的一分一毫對我們的工作有極大意義，請支持我們，讓更多
            人在更多時候都能「停一停 卓嶺有限公司」！
          </p>
          <p>感謝您！</p>
        </div>
        <InputDonationCard {...inputCardProps} />
        <div className={`my-5 btns-gp-div`}>
          <Button sx={{ marginRight: 2 }} onClick={() => reset()} style={{ borderColor: "#fa8123", color: "#fa8123" }}>
            {t("Clear")}
          </Button>
          <Button
            type="submit"
            // onClick={() => onSubmit()}
            variant="contained"
            style={{
              backgroundColor: "#FFA836", // Change this color to your desired color
              color: "#FFFFFF", // Change the text color if needed
            }}
          >
            {t("Submit")}
            
          </Button>
        </div>
      </form>
      {/* <div>{`event ${id || "none"}`}</div> */}
    </div>
  );
};

export default DonationPage;
